import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=0534c5f0&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0534c5f0')) {
      api.createRecord('0534c5f0', component.options)
    } else {
      api.reload('0534c5f0', component.options)
    }
    module.hot.accept("./Autocomplete.vue?vue&type=template&id=0534c5f0&", function () {
      api.rerender('0534c5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/Autocomplete.vue"
export default component.exports